const lbLoadingPlaceholder = angular.module('app.lbLoadingPlaceholder', []);

lbLoadingPlaceholder.component('lbLoadingPlaceholder', require('./lbLoadingPlaceholder'));
lbLoadingPlaceholder.component('lbLoadingPlaceholderItem', require('./lbLoadingPlaceholderItem'));
lbLoadingPlaceholder.controller('lbLoadingPlaceholderItemCtrl', require('./lbLoadingPlaceholderItemCtrl'));

export default lbLoadingPlaceholder;



// WEBPACK FOOTER //
// ./src/components/lbLoadingPlaceholder/index.js